import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const SpringPreset = definePreset(Aura, {
  semantic: {
    primary: palette('#6ca12b'),
  },
});

export default SpringPreset;
